import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { HomeFeedEngine } from '../../types/product.types';

export type SearchSessionReducer = {
  activeSearchGuid: string | null;
  activeRecommendationId: string | null;
  activeRecommendationEngine: HomeFeedEngine | null;
  productSlug: string | null;
};

const initialState: SearchSessionReducer = {
  activeSearchGuid: null,
  activeRecommendationId: null,
  activeRecommendationEngine: null,
  productSlug: null,
};

const searchSessionSlice = createSlice({
  name: 'searchSession',
  initialState,
  reducers: {
    setActiveOrigin(
      state,
      action: PayloadAction<{
        productSlug: string;
        searchGuid?: string;
        recommendationId?: string;
        recommendationEngine?: HomeFeedEngine;
      }>,
    ) {
      const { productSlug, searchGuid, recommendationId, recommendationEngine } = action.payload;

      state.productSlug = productSlug;
      state.activeSearchGuid = searchGuid || null;
      state.activeRecommendationId = searchGuid ? null : recommendationId || null;
      state.activeRecommendationEngine = searchGuid ? null : recommendationEngine || null;
    },
    clearActiveOrigin(state) {
      state.activeSearchGuid = null;
      state.activeRecommendationId = null;
      state.activeRecommendationEngine = null;
      state.productSlug = null;
    },
  },
});

export const searchSessionActions = searchSessionSlice.actions;

export default searchSessionSlice.reducer;
